
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */



// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

require( 'bootstrap' );


/**
 * Load Jquery-Validation Plugin
 */
// require( 'jquery-validation' );
import "jquery-validation";

/**
 * Load Bootstrap-datepicker
 */
// require('bootstrap-datepicker');
import "bootstrap-datepicker";


require( 'chosen-js/chosen.jquery' );
// import 'chosen-js/chosen.jquery';

// require( 'datatables.net/js/jquery.dataTables' );
// require( 'datatables.net-bs5/js/dataTables.bootstrap5' );
// require( 'datatables.net-buttons/js/dataTables.buttons');

import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-bs5/js/dataTables.bootstrap5';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons-bs5/js/buttons.bootstrap5';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));
//
// const app = new Vue({
//     el: '#app'
// });

// Redirect token mismatch requests for ajax calls
window.$(document).ready(function(){
    window.$.ajaxSetup({
        statusCode: {
            440: function() {
                console.log('Redirecting');
                window.location.href = '/440';
            }
        }
    });


    // Below code was take from thesoutherninsurancegroup.com and is what make the mobile menu work
    et_duplicate_menu( window.$('#et-top-navigation ul.nav'), window.$('#et-top-navigation .mobile_nav'), 'mobile_menu', 'et_mobile_menu' );
    et_duplicate_menu( window.$('.et_pb_fullwidth_menu ul.nav'), window.$('.et_pb_fullwidth_menu .mobile_nav'), 'mobile_menu', 'et_mobile_menu' );

    function et_duplicate_menu( menu, append_to, menu_id, menu_class ){
        var $cloned_nav;

        menu.clone().attr('id',menu_id).removeClass().attr('class',menu_class).appendTo( append_to );
        $cloned_nav = append_to.find('> ul');
        $cloned_nav.find('.menu_slide').remove();
        $cloned_nav.find('li:first').addClass('et_first_mobile_item');

        append_to.click( function(){
            if ( window.$(this).hasClass('closed') ){
                window.$(this).removeClass( 'closed' ).addClass( 'opened' );
                $cloned_nav.slideDown( 500 );
            } else {
                window.$(this).removeClass( 'opened' ).addClass( 'closed' );
                $cloned_nav.slideUp( 500 );
            }
            return false;
        } );

        append_to.find('a').click( function(event){
            event.stopPropagation();
        } );
    }

    if ( window.$( '#et-secondary-nav' ).length ) {
        window.$('#et-top-navigation #mobile_menu').append( window.$( '#et-secondary-nav' ).clone().html() );
    }

});
